import React, { Component } from 'react';
import './style.scss';
import Part from '../part';
import PropTypes from 'prop-types';

class Level extends Component {


    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            selectedPart: this.props.level ? (this.props.level.parts ? this.props.level.parts[0] : null) : null
        }
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevProps.level !== this.props.level) {
            this.setState({
                currentIndex: 0,
                selectedPart: this.props.level ? (this.props.level.parts ? this.props.level.parts[0] : null) : null
            })
        }
    }


    renderSelectedPart() {
        return <Part part={this.state.selectedPart} index={this.state.currentIndex}></Part>
    }

    handleButtonOnClick = (index, parts) => {
        this.setState({
            selectedPart: parts[index],
            currentIndex: index
        });
    }

    render() {
        if (this.props.level && this.props.level.parts) {
            const { parts, label } = this.props.level;
            return (
                <div className="level">
                    <h4>{label}</h4>
                    <div className="select-part">
                        <button className={this.state.currentIndex === 0 ? ' part-button active' : 'part-button'} onClick={() => this.handleButtonOnClick(0, parts)}>Part 1</button>
                        <button className={this.state.currentIndex === 1 ? ' part-button active' : 'part-button'} onClick={() => this.handleButtonOnClick(1, parts)}>Part 2</button>
                        <button className={this.state.currentIndex === 2 ? ' part-button active' : 'part-button'} onClick={() => this.handleButtonOnClick(2, parts)}>Part 3</button>
                        <button className={this.state.currentIndex === 3 ? ' part-button active' : 'part-button'} onClick={() => this.handleButtonOnClick(3, parts)}>Part 4</button>
                    </div>
                    {this.renderSelectedPart()}
                </div>
            );
        } else {
            return (
                <div>Empty</div>
            )
        }
    }
}


Level.propTypes = {
    level: PropTypes.object.isRequired,
};

export default Level;